<div class="container" fxLayout="column">

  <div class="panel" fxLayout="row" fxLayoutGap="10px">
    <div fxLayout="column" fxFlex="70" [fxFlex]="plainText ? 100 : 70">
      <div id="quill-editor"></div>
    </div>

    <div fxLayout="column" fxFlex="30" *ngIf="!plainText">
    <mat-accordion class="mat-elevation-z0">
      <mat-expansion-panel class="mat-elevation-z0">
        <mat-expansion-panel-header>
          <mat-panel-title>
           Δεσμευμένα πεδία
          </mat-panel-title>
          <mat-panel-description>
            Αντιγράψετε τα πεδία και εισάγετε τα στο κείμενό σας.
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="column" fxLayoutGap="8px" style="padding: 10px 0;">

          <!-- Έτοιμο κείμενο Ελληνικά -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" class="copyRow"
               (click)="copyLink('Για να συμπληρώσετε τη δήλωση, πατήστε τον παρακάτω σύνδεσμο: [link]')"
               fxLayoutGap="5px"
               style="padding: 8px; border-radius: 8px; cursor: pointer; transition: background 0.2s;"
               matTooltip="Κλικ για αντιγραφή">
            <div fxLayout="column" fxFlex="85">
              <label style="font-weight: 600; color: #0a1628; cursor: pointer;">Κείμενο με σύνδεσμο (GR)</label>
              <label style="font-size: 11px; color: #64748b; cursor: pointer;">Για να συμπληρώσετε τη δήλωση, πατήστε τον παρακάτω σύνδεσμο</label>
            </div>
            <div fxLayout="column">
              <mat-icon style="color: #00bfa5;">content_copy</mat-icon>
            </div>
          </div>

          <!-- Έτοιμο κείμενο Αγγλικά -->
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" class="copyRow"
               (click)="copyLink('To fill in the declaration, please click the following link: [link-en]')"
               fxLayoutGap="5px"
               style="padding: 8px; border-radius: 8px; cursor: pointer; transition: background 0.2s;"
               matTooltip="Κλικ για αντιγραφή">
            <div fxLayout="column" fxFlex="85">
              <label style="font-weight: 600; color: #0a1628; cursor: pointer;">Text with link (EN)</label>
              <label style="font-size: 11px; color: #64748b; cursor: pointer;">To fill in the declaration, please click the following link</label>
            </div>
            <div fxLayout="column">
              <mat-icon style="color: #00bfa5;">content_copy</mat-icon>
            </div>
          </div>

        </div>

      </mat-expansion-panel>
    </mat-accordion>
    </div>

  </div>
</div>
